<template>
  <div class="legal">
   <v-container class="pt-md-8" style="max-width: 1000px; margin: 0 auto;">
      <v-row>
        <v-col cols="12" class="text-body-2 text-md-subtitle-1 text-justify">
          <div class="pt-5 mb-4">
            <h1 class="mb-4">
              <strong class="primary--text text-h6 text-md-h5 font-weight-bold" v-translate>About cookies</strong>
            </h1>

            <h2 class="mb-4">
              <strong class="text-subtitle-1 text-md-h6 font-weight-bold" v-translate>What are cookies ?</strong>
            </h2>

            <p v-translate>
              Cookies are small text files that contain a string of characters. They can be placed on your computer or mobile device and uniquely identify your browser or device. We may use technologies such as cookies, pixels, and local storage to display, protect, and understand products, services, and advertisements.
            </p>

            <h2 class="mb-4">
              <strong class="text-subtitle-1 text-md-h6 font-weight-bold" v-translate>What are cookies used for?</strong>
            </h2>

            <p v-translate>
              Cookies and other technologies allow a site or service to know whether your computer or device has visited it before. These technologies can be used to display products, services and advertisements, to help us understand how the site or service is used, to help you navigate between pages efficiently, to help remember your preferences and, in general, to improve your experience when you use our services. Cookies also help make sure that the marketing you see online is most relevant to you and to your interests.
            </p>

            <h2 class="mb-4">
              <strong class="text-subtitle-1 text-md-h6 font-weight-bold" v-translate>Why does BGC use cookies and similar technologies?</strong>
            </h2>

            <p v-translate>
              We use cookies, pixels, local storage and similar technologies to show you relevant content, to improve your experience, and to help us protect BGC and our users. We may use these technologies to provide the service, to provide you with an easy-to-use service, to enable you to navigate the service and use its features, such as accessing secure areas, and to store information in order to accelerate the response of BGC. We may use these technologies to collect information about your use of the service, such as which pages you visit most often or if you receive error messages from certain pages. We may use these technologies to allow us to remember the choices you make (such as your username, language or region you are in) and to personalize the service to provide you with features and content. improved. These cookies can also be used to remember changes you have made to text size, font, and other elements of pages that you can customize. BGC or its advertising partners may use these technologies to show you advertisements that match your interests. These technologies may remember that your device has visited a site or service, and may also be able to track your device's browsing activity on sites or services other than BGC. This information may be shared with organizations outside of BGC, such as advertisers or ad networks, to serve advertisements and to help measure the effectiveness of an advertising campaign. * We may use these technologies to understand, improve, and research products and services.


            </p>

            <h2 class="mb-4">
              <strong class="text-subtitle-1 text-md-h6 font-weight-bold" v-translate>How long will cookies stay on my device?</strong>
            </h2>

            <p v-translate>
              The length of time a cookie will remain on your computer or mobile device will differ depending on whether it is a "permanent" or "session" cookie. Session cookies will only stay on your device for as long as you are browsing. Persistent cookies will remain on your computer or mobile device until they expire or are deleted.
            </p>

            <h2 class="mb-4">
              <strong class="text-subtitle-1 text-md-h6 font-weight-bold" v-translate>Internal or third-party cookies</strong>
            </h2>

            <p v-translate>
              First-party cookies are cookies that belong to BGC. Third-party cookies are cookies that a third party places on your device through our service. Third-party cookies may be placed on your device by someone who provides a service for BGC, for example to help us understand how our service is used. Third-party cookies may also be placed on your device by our business partners so that they can use them to advertise products and services to you elsewhere on the Internet.
            </p>

            <h2 class="mb-4">
              <strong class="text-subtitle-1 text-md-h6 font-weight-bold" v-translate>How to control cookies or other collection mechanisms?</strong>
            </h2>

            <p v-translate>
              Follow the instructions provided by your website or mobile browser (usually located in the “Help”, “Tools” or “Edit” menus) to change your cookie settings. Note that if you configure your browser to disable cookies or other technologies, you may no longer be able to access certain parts of our service and other parts of it may not work. correctly.
            </p>

            <p v-translate>
              In addition, your browser or device may have settings that allow you to choose whether browser cookies are enabled and to delete them. These controls vary by browser, and manufacturers can change the available settings and how they work at any time.
            </p>


          </div>

        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Legal",
  metaInfo() {
    return {
      title: this.$gettext("Golf - Legal mentions"),
    };
  },
  components: { },
  mounted () {
    window.scrollTo(0, 0)
  }
};
</script>